import assign from 'lodash/assign';

import './overlay.scss';

export const OverlayControllerModule = angular
    .module('app.components.overlay.overlayController', ['ngMaterial'])
    .controller('OverlayController', ($scope, $mdDialog) => {
        init();

        function init() {
            assign($scope, {
                close,
                hideCloseButton,
                showCloseButton
            });
            showCloseButton();
        }

        function close() {
            $mdDialog.hide();
        }

        function hideCloseButton() {
            $scope.closeButtonVisible = false;
        }

        function showCloseButton() {
            $scope.closeButtonVisible = true;
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/overlay/overlay.controller.js